import { render } from "./ProductsDetailDepth.vue?vue&type=template&id=222fc932"
import script from "./ProductsDetailDepth.vue?vue&type=script&lang=js"
export * from "./ProductsDetailDepth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__